var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -12 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "stroke",
    strokeWidth: 1,
    fill: "fill",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Set",
    transform: "translate(-412.000000, -1047.000000)",
    fill: "fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440,1053 L416,1053 C414.896,1053 414,1052.1 414,1051 C414,1049.9 414.896,1049 416,1049 L440,1049 C441.104,1049 442,1049.9 442,1051 C442,1052.1 441.104,1053 440,1053 L440,1053 Z M440,1047 L416,1047 C413.791,1047 412,1048.79 412,1051 C412,1053.21 413.791,1055 416,1055 L440,1055 C442.209,1055 444,1053.21 444,1051 C444,1048.79 442.209,1047 440,1047 L440,1047 Z",
    id: "minus"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.bf7a232e71eec2938b616106c7f3cca4.svg";
export { ForwardRef as ReactComponent };